import React from 'react';
import "./NotFound.scss";
import { useNavigate } from 'react-router-dom';
import NotFoundImg from '../../assets/images/not-found.svg';

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="not-found-container">
            <div className="not-found-image">
                <img src={NotFoundImg} alt="Not Found" height={300}/>
            </div>
            <div className="not-found-text">
                <h1>Oops! 404</h1>
                <h2>We can't find that page</h2>
                <p>The page you're looking for might have been removed or is temporarily unavailable.</p>
                <button className="back-home" onClick={() => navigate('/')}>
                    Back to Home
                </button>
            </div>
        </div>
    );
};

export default NotFound;